import { FileWithPath } from "../files.types";

// Helper function to recursively traverse folder contents
export const traverseFileTree = (
  item: FileSystemEntry
): Promise<FileWithPath[]> => {
  return new Promise((resolve, reject) => {
    const files: FileWithPath[] = [];

    if (item.isFile) {
      // It's a file
      const fileEntry = item as FileSystemFileEntry;
      fileEntry.file(
        (file) => {
          // Store both the file and its path
          files.push({
            file,
            path: item.fullPath,
          });
          resolve(files);
        },
        (error) => {
          console.error("Error reading file:", item.fullPath, error);
          resolve(files); // Resolve with empty array instead of rejecting
        }
      );
    } else if (item.isDirectory) {
      // It's a directory
      const dirEntry = item as FileSystemDirectoryEntry;
      const dirReader = dirEntry.createReader();

      const readEntries = () => {
        dirReader.readEntries(
          async (entries) => {
            if (entries.length === 0) {
              // No more entries
              resolve(files);
              return;
            }

            try {
              // Process all entries in this directory
              const promises = entries.map((entry) => traverseFileTree(entry));
              const results = await Promise.allSettled(promises);

              results.forEach((result) => {
                if (result.status === "fulfilled") {
                  files.push(...result.value);
                } else {
                  console.error(
                    "Error processing directory entry:",
                    result.reason
                  );
                }
              });

              // Continue reading (directories might have more entries)
              readEntries();
            } catch (error) {
              console.error("Error processing directory entries:", error);
              resolve(files);
            }
          },
          (error) => {
            console.error("Error reading directory:", item.fullPath, error);
            resolve(files); // Resolve with what we have so far
          }
        );
      };

      readEntries();
    } else {
      // Unknown entry type, resolve with empty array
      resolve(files);
    }
  });
};
